/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import styles from './Badge.module.scss';

import type { BadgeProps } from './Badge.types';

export const Badge = ({ children, variant = 'default', size = 'md', uppercase = false, className }: BadgeProps) => {
  return (
    <span
      className={cn(
        styles.badge,
        styles[`badge_${variant}`],
        styles[`badge_${size}`],
        uppercase && styles.badge_uppercase,
        className,
      )}
    >
      {children}
    </span>
  );
};
